import { type MaybeRef } from '@vueuse/core';

export function useStoryblokArticles({
    categories,
    featured,
    page = 1,
    perPage = 20,
    filters = {},
}: {
    categories?: MaybeRef<string[]>
    featured?: MaybeRef<boolean>
    page?: MaybeRef<number>
    perPage?: MaybeRef<number>
    filters?: MaybeRef<Record<string, unknown>>
}) {
    const { t } = useI18n({
        useScope: 'global',
    });

    const filterQuery = computed(() => {
        const categoriesString = unref(categories)?.join(',');
        const categoriesFilter = categoriesString ? {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            category: { any_in_array: categoriesString },
        } : {};
        const featuredValue = unref(featured);
        const featuredFilter = featuredValue === undefined ? {} : {
            featured: { is: featuredValue },
        };

        const filterValue = unref(filters);
        const additionalFilter = filterValue === undefined ? {} : {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            ...filterValue,
        };
        return {
            // Rule out non-article page types
            // eslint-disable-next-line @typescript-eslint/naming-convention
            component: { not_in: 'sb-articles-lander' },
            ...featuredFilter,
            ...categoriesFilter,
            ...additionalFilter,
        };
    });

    const fetchKey = `storyblok-category-articles:(${unref(categories)?.join('|')})`
        + `-featured:${unref(featured)}-perPage:${unref(perPage)}-filterQuery:${unref(filters)}`;

    return useStoryblokStoriesData(fetchKey, {
        /* eslint-disable @typescript-eslint/naming-convention */
        starts_with: `${t('storyblok.articles')}`,
        sort_by: 'first_published_at:desc',
        page,
        per_page: perPage,
        is_startpage: false,
        filter_query: filterQuery,
        /* eslint-enable @typescript-eslint/naming-convention */
    });
}
